module.exports = __webpack_public_path__ + "static/media/o_config_down-arrow.425bcbf7.svg";